<app-header class="header" id="header" (logout)="logout()"></app-header>

<router-outlet></router-outlet>

<app-footer class="footer"></app-footer>